import { render, staticRenderFns } from "./popup-do-zi-duan.vue?vue&type=template&id=0f68238e&scoped=true"
import script from "./popup-do-zi-duan.vue?vue&type=script&lang=js"
export * from "./popup-do-zi-duan.vue?vue&type=script&lang=js"
import style0 from "./popup-do-zi-duan.vue?vue&type=style&index=0&id=0f68238e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f68238e",
  null
  
)

export default component.exports